require('./brokerStocksPurchaseOrderStep2.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @components
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const OKTooltip = require('commonsComponents/OKTooltip');
const { OKMessage } = require('commonsComponents/OKMessage');
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
import BrokerLegalDocumentation from 'components/broker/brokerLegalDocumentation/brokerLegalDocumentation';

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @constants
const {
    SECOND_STEP,
    BROKER_REQUEST_FINANCIAL_OPERATION_CHANGE_SIGNATURE_PATTERN_OPERATION_TYPE,
    BROKER_PRODUCT_TYPE_OPV
} = require('constants/index');
const CLASS_NAME = 'broker-stocks-purchase-order-step2';

const BrokerStocksPurchaseOrderStep2 = props => {
    const { immBrokerStocksPurchaseOrder, actions, onChangeManifest, cancelButton, nextButton, setDocumentsRead } = props;
    const product = immBrokerStocksPurchaseOrder.getIn(['contract', 'product']);
    const contractNumber = immBrokerStocksPurchaseOrder.getIn(['contract', 'number']);
    const secondStep = immBrokerStocksPurchaseOrder.getIn(['steps', SECOND_STEP]);
    const showWarning = secondStep.get('showWarning');
    const secondStepLoading = secondStep.get('loading');
    const manifest = secondStep.get('acceptedManifest');
    const manifestNotChecked = secondStep.getIn(['errorFlags', 'manifestNotChecked']);
    const productDefinition = immBrokerStocksPurchaseOrder.getIn(['operation', 'descriptionValue']);
    const signaturePatternParams = {
        chargeAccount: `00730100${product}${contractNumber}`
    };
    const isin = immBrokerStocksPurchaseOrder.getIn(['operation', 'isin'])
    const iso = immBrokerStocksPurchaseOrder.getIn(['operation', 'iso'])
    const showSignaturePattern = () => {
        setDocumentsRead();
    }

    let documentsNotRead = null;
    if (showWarning) {
        documentsNotRead = (
            <div className={`${CLASS_NAME}__warning-message`}>
                <OKMessage type="warning">
                    <FormattedText value="brokerLegalDocumentation-documentsRead" />
                </OKMessage>
            </div>
        )
    }

    let signaturePattern = null;
    if (secondStep.get('acceptedManifest')) {
        signaturePattern = (
            <div className={`${CLASS_NAME}__signature-pattern`}>
                <SignaturePattern
                    operationType={BROKER_REQUEST_FINANCIAL_OPERATION_CHANGE_SIGNATURE_PATTERN_OPERATION_TYPE}
                    operationParams={signaturePatternParams}
                />
            </div>
        )
    }

    return (
        <WizardStep
            actions={actions}
            cancelButton={cancelButton}
            finishButton={nextButton}
            immFinalButton="stocksPurchaseOrder-emit"
            position="last"
            isLoading={secondStepLoading}
            addLoadingBehaviour={nextButton}
        >
            <h4 className={`${CLASS_NAME}__header-title`}>
                <FormattedText value="stocksPurchaseOrder-orderConfirmation"/>
            </h4>
            <div className={`${CLASS_NAME}__info`}>
                <FormattedText value="stocksPurchaseOrder-verifyInformation"/>
            </div>
            <div className={`${CLASS_NAME}__field`}>
                <BrokerLegalDocumentation
                    isin={isin}
                    iso={iso}
                    isAportation={false}
                    productDefinition={productDefinition}
                    productType={BROKER_PRODUCT_TYPE_OPV}
                    reportCompleted={() => showSignaturePattern()}
                />
                {documentsNotRead}
                <OKTooltip
                    content={<FormattedText value={'planLegalDocumentDisclaimer-warningTooltip'}/>}
                    offset={[-50, -5]}
                    placement={'topLeft'}
                    target={
                        <div className={`${CLASS_NAME}__disclaimer`}>
                            <OKCheckbox
                                idName="manifest"
                                label={formatText('stocksPurchaseOrder-manifest')}
                                value={manifest}
                                onChange={onChangeManifest}
                                errorState={manifestNotChecked}
                                errorMessage={formatText('requestFinancialOperationChange-checkError')}
                            />
                        </div>
                    } />
            </div>
            {signaturePattern}
        </WizardStep>
    );
};

BrokerStocksPurchaseOrderStep2.propTypes = {
    immBrokerStocksPurchaseOrder: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    onChangeManifest: PropTypes.func.isRequired,
    cancelButton: PropTypes.bool,
    nextButton: PropTypes.bool,
    setDocumentsRead: PropTypes.func.isRequired
};

BrokerStocksPurchaseOrderStep2.defaultProps = {
    cancelButton: true,
    nextButton: true
}

module.exports = BrokerStocksPurchaseOrderStep2;
